
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Form, Input, Layout, Empty, Space, Card, Carousel, Button, Select, Modal, Tabs, Descriptions, Typography, Table } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';
import MyComp from '../comp/my-comp.js';
import { IconFilePdf, IconSearch } from '@arco-design/web-react/icon';
import * as news_config from '../common/news_config'


const Option = Select.Option;
const FormItem = Form.Item;
const InputSearch = Input.Search;
const TabPane = Tabs.TabPane;
const { Title, Paragraph } = Typography;

export default class App extends MyComp {
  constructor(props) {
    super(props);


    this.state = {

    }


  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize()

  }
  componentWillReceiveProps(nextProps) {

  }
  getTable1() {
    let columns = [{
      title: '术语',
      dataIndex: 'term',
    }, {
      title: '解释',
      dataIndex: 'desc',
    }, {
      title: 'BPM',
      dataIndex: 'bpm',
    }]
    //     术语	解释	BPM
    // adagietto	小柔板，比柔板稍快	72-76
    // adagio	柔板	66-76
    // allegretto	稍快板，比快板稍快	112-120
    // allegrissimo	极快的快板	172-176
    // allegro	快板	120-168
    // allegro moderato	中庸的快板，比快板稍慢	116-120
    // andante	行板	76-108
    // andante moderato	中庸的行板，比行板稍快	92-112
    // andantino	小行板，比行板稍快	80-108
    // grave	缓板	25-45
    // larghetto	稍缓板，比慢板稍快	60-66
    // larghissimo	极慢板	25 或以下
    // largo	慢板	40-60
    // lento	慢	45-60
    // moderato	中板	108-120
    // prestissimo	最急板	200 或以上
    // presto	急板	168-200
    // vivace	活泼的快板	140-176
    // vivacissimo	极活泼的快板	172-176
    let data = [
      {
        term: 'adagietto',
        desc: '小柔板，比柔板稍快',
        bpm: '72-76',
      },
      {
        term: 'adagio',
        desc: '柔板',
        bpm: '66-76',
      },
      {
        term: 'allegretto',
        desc: '稍快板，比快板稍快',
        bpm: '112-120',
      },
      {
        term: 'allegrissimo',
        desc: '极快的快板',
        bpm: '172-176',
      },
      {
        term: 'allegro',
        desc: '快板',
        bpm: '120-168',
      },
      {
        term: 'allegro moderato',
        desc: '中庸的快板，比快板稍慢',
        bpm: '116-120',
      },
      {
        term: 'andante',
        desc: '行板',
        bpm: '76-108',
      },
      {
        term: 'andante moderato',
        desc: '中庸的行板，比行板稍快',
        bpm: '92-112',
      },
      {
        term: 'andantino',
        desc: '小行板，比行板稍快',
        bpm: '80-108',
      },
      {
        term: 'grave',
        desc: '缓板',
        bpm: '25-45',
      },
      {
        term: 'largo',
        desc: '慢板',
        bpm: '40-60',
      },
      {
        term: 'lento',
        desc: '慢',
        bpm: '45-60',
      },
      {
        term: 'moderato',
        desc: '中板',
        bpm: '108-120',
      },
      {
        term: 'prestissimo',
        desc: '最急板',
        bpm: '200 或以上',
      },
      {
        term: 'presto',
        desc: '急板',
        bpm: '168-200',
      },
      {
        term: 'vivace',
        desc: '活泼的快板',
        bpm: '140-176',
      },
      {
        term: 'vivacissimo',
        desc: '极活泼的快板',
        bpm: '172-176',
      },


    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable2() {
//     术语	缩写	解释
// a piacere		速度任由演奏者决定
// a tempo		恢复先前的速度
// rallentando	rall.	渐慢
// ritardando	rit., ritard.	渐慢
// ritenuto	riten.	立即慢下来
// rubato		弹性速度
// stringendo		渐快，字面上有“收紧”之意
// accelerando	accel.	渐快
    let columns = [{
      title: '术语',
      dataIndex: 'term',
    }, {
      title: '缩写',
      dataIndex: 'abbr',
    }, {
      title: '解释',
      dataIndex: 'desc',
    }]
    let data = [
      {
        term: 'a piacere',
        abbr: '',
        desc: '速度任由演奏者决定',
      },
      {
        term: 'a tempo',
        abbr: '',
        desc: '恢复先前的速度',
      },
      {
        term: 'rallentando',
        abbr: 'rall.',
        desc: '渐慢',
      },
      {
        term: 'ritardando',
        abbr: 'rit., ritard.',
        desc: '渐慢',
      },
      {
        term: 'ritenuto',
        abbr: 'riten.',
        desc: '立即慢下来',
      },
      {
        term: 'rubato',
        abbr: '',
        desc: '弹性速度',
      },
      {
        term: 'stringendo',
        abbr: '',
        desc: '渐快，字面上有“收紧”之意',
      },
      {
        term: 'accelerando',
        abbr: 'accel.',
        desc: '渐快',
      },
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable3() {
    // 术语	符号	解释
    // pianississimo	ppp	最弱
    // pianissimo	pp	极弱
    // piano	p	弱
    // mezzo piano	mp	中弱
    // mezzo forte	mf	中强
    // forte	f	强
    // fortissimo	ff	极强
    // fortississimo	fff	最强
    let columns = [
      {title: '术语',dataIndex: 'term'},
      {title: '符号',dataIndex: 'symbol'},
      {title: '解释',dataIndex: 'desc'}
    ]
    let data = [
      {term: 'pianississimo',symbol: 'ppp',desc: '最弱'},
      {term: 'pianissimo',symbol: 'pp',desc: '极弱'},
      {term: 'piano',symbol: 'p',desc: '弱'},
      {term: 'mezzo piano',symbol: 'mp',desc: '中弱'},
      {term: 'mezzo forte',symbol: 'mf',desc: '中强'},
      {term: 'forte',symbol: 'f',desc: '强'},
      {term: 'fortissimo',symbol: 'ff',desc: '极强'},
      {term: 'fortississimo',symbol: 'fff',desc: '最强'}
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable4() {
    // 术语	符号	解释
    // crescendo	cresc. 或 Crescendo	渐强
    // diminuendo	dim. 或 Diminuendo	渐弱
    // fortepiano	fp	强后即弱
    // sforzando, forzando, szforzato	sfz, sf 或 fz	突强（用于音符或和弦）
    // rinforzando	rfz 或 rf	突强（用于音符、和弦或乐句）
    let columns = [
      {title: '术语',dataIndex: 'term'},
      {title: '符号',dataIndex: 'symbol'},
      {title: '解释',dataIndex: 'desc'}
    ]
    let data = [
      {term: 'crescendo',symbol: 'cresc. 或 Crescendo',desc: '渐强'},
      {term: 'diminuendo',symbol: 'dim. 或 Diminuendo',desc: '渐弱'},
      {term: 'fortepiano',symbol: 'fp',desc: '强后即弱'},
      {term: 'sforzando, forzando, szforzato',symbol: 'sfz, sf 或 fz',desc: '突强（用于音符或和弦）'},
      {term: 'rinforzando',symbol: 'rfz 或 rf',desc: '突强（用于音符、和弦或乐句）'}
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable5(){
//     术语	缩写	解释
// arpeggio	arp.	琶音；指和弦的音由低到高或由高到低依次奏出
// glissando	gliss.	滑音；指两个音之间连续变化音高，以达到上下运行的效果
// legato		连奏又称连音，是一种音与音平滑相连的演奏法
// mano destra	m.d.	右手
// mano sinistra	m.s.	左手
// con sordino		加弱音踏板，或者不加延音踏板（以钢琴为例）
// senza sordino		不加弱音踏板，或者加延音踏板（以钢琴为例）
// pizzicato	pizz.	拨奏；用手指拨出声响，而不是使用弓来拉奏
// portamento	port.	滑音；指两个音之间连续变化音高，以达到上下运行的效果
// tutti		乐团全体演奏
// staccato	stacc.	断音奏法；音与音之间不连接
// staccatissimo	staccatiss.	特短断音奏法；音与音之间明显分隔
// vibrato		抖音；音符的音调快速反复微变化
    let columns = [
      {title: '术语',dataIndex: 'term'},
      {title: '缩写',dataIndex: 'symbol'},
      {title: '解释',dataIndex: 'desc'}
    ]
    let data = [
      {term: 'arpeggio',symbol: 'arp.',desc: '琶音；指和弦的音由低到高或由高到低依次奏出'},
      {term: 'glissando',symbol: 'gliss.',desc: '滑音；指两个音之间连续变化音高，以达到上下运行的效果'},
      {term: 'legato',symbol: '',desc: '连奏又称连音，是一种音与音平滑相连的演奏法'},
      {term: 'mano destra',symbol: 'm.d.',desc: '右手'},
      {term: 'mano sinistra',symbol: 'm.s.',desc: '左手'},
      {term: 'con sordino',symbol: '',desc: '加弱音踏板，或者不加延音踏板（以钢琴为例）'},
      {term: 'senza sordino',symbol: '',desc: '不加弱音踏板，或者加延音踏板（以钢琴为例）'},
      {term: 'pizzicato',symbol: 'pizz.',desc: '拨奏；用手指拨出声响，而不是使用弓来拉奏'},
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable6(){
    // 术语	解释
    // agitato	激动、急促的
    // animato	活泼、精神焕发的
    // cantabile	如歌似的
    // con amore	带有爱的
    // con brio	充满活力的
    // con fuoco	如火如荼的
    // con moto	活跃的
    // dolce	甜蜜的
    // doloroso	悲伤的
    // energico	精力充沛的
    // espressivo	充满感情的
    // grazioso	优雅的
    // leggiero	轻快的
    // maestoso	庄严的
    // marcato	用力的
    // risoluto	坚决有力的
    // scherzando	诙谐的
    // sostenuto	延宕的
    // tenuto	持续的
    // tranquillo	宁静的
    let columns = [
      {title: '术语',dataIndex: 'term'},
      {title: '解释',dataIndex: 'desc'}
    ]
    let data = [
      {term: 'agitato',desc: '激动、急促的'},
      {term: 'animato',desc: '活泼、精神焕发的'},
      {term: 'cantabile',desc: '如歌似的'},
      {term: 'con amore',desc: '带有爱的'},
      {term: 'con brio',desc: '充满活力的'},
      {term: 'con fuoco',desc: '如火如荼的'},
      {term: 'con moto',desc: '活跃的'},
      {term: 'dolce',desc: '甜蜜的'},
      {term: 'doloroso',desc: '悲伤的'},
      {term: 'energico',desc: '精力充沛的'},
      {term: 'espressivo',desc: '充满感情的'},
      {term: 'grazioso',desc: '优雅的'},
      {term: 'leggiero',desc: '轻快的'},
      {term: 'maestoso',desc: '庄严的'},
      {term: 'marcato',desc: '用力的'},
      {term: 'risoluto',desc: '坚决有力的'},
      {term: 'scherzando',desc: '诙谐的'},
      {term: 'sostenuto',desc: '延宕的'},
      {term: 'tenuto',desc: '持续的'},
      {term: 'tranquillo',desc: '宁静的'},
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable7(){
    // 术语	记号	解释
    // Fine		反复到此记号结尾
    // Coda	Coda	表示该段落为乐章结尾
    // Segno	Segno	反复的开端或结尾
    // Da Capo	D.C.	从头再奏
    // Da Capo al Fine	D.C. al Fine	从头再奏后，演奏到 Fine 记号为止
    // Da Capo al Coda	D.C. al Coda	从头再奏后，演奏到 Coda 记号为止（有时会以 To Coda 取代），再跳至第二个记号完结
    // Da Capo al Segno	D.C. al Segno	从头再奏后，演奏到 Segno 记号为止
    // Dal Segno	D.S.	从 Segno 记号再奏
    // Dal Segno al Fine	D.S. al Fine	从 Segno 记号再奏，演奏到 Fine 记号为止
    // Dal Segno al Coda	D.S. al Coda	从 Segno 记号再奏，演奏到 Coda 记号（有时会以 To Coda 取代），再跳至第二个记号完结
    let columns = [
      {title: '术语',dataIndex: 'term'},
      {title: '记号',dataIndex: 'symbol'},
      {title: '解释',dataIndex: 'desc'}
    ]
    let data = [
      {term: 'Fine',symbol: '',desc: '反复到此记号结尾'},
      {term: 'Coda',symbol: 'Coda',desc: '表示该段落为乐章结尾'},
      {term: 'Segno',symbol: 'Segno',desc: '反复的开端或结尾'},
      {term: 'Da Capo',symbol: 'D.C.',desc: '从头再奏'},
      {term: 'Da Capo al Fine',symbol: 'D.C. al Fine',desc: '从头再奏后，演奏到 Fine 记号为止'},
      {term: 'Da Capo al Coda',symbol: 'D.C. al Coda',desc: '从头再奏后，演奏到 Coda 记号为止（有时会以 To Coda 取代），再跳至第二个记号完结'},
      {term: 'Da Capo al Segno',symbol: 'D.C. al Segno',desc: '从头再奏后，演奏到 Segno 记号为止'},
      {term: 'Dal Segno',symbol: 'D.S.',desc: '从 Segno 记号再奏'},
      {term: 'Dal Segno al Fine',symbol: 'D.S. al Fine',desc: '从 Segno 记号再奏，演奏到 Fine 记号为止'},
      {term: 'Dal Segno al Coda',symbol: 'D.S. al Coda',desc: '从 Segno 记号再奏，演奏到 Coda 记号（有时会以 To Coda 取代），再跳至第二个记号完结'},
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getTable8(){
//     Term	Meaning
// ad libitum	任意（通常指的是速度和风格）
// assai	非常
// con	带有
// ma	但
// ma non tanto	但不太
// ma non troppo	但不过分
// meno	较不
// molto	甚
// non	不
// più	更
// poco	稍微
// poco a poco	逐渐
// senza	无、不带有
// simile	按照、同
// subito	突然、快速
    let columns = [
      {title: 'Term',dataIndex: 'term'},
      {title: 'Meaning',dataIndex: 'desc'}
    ]
    let data = [
      {term: 'ad libitum',desc: '任意（通常指的是速度和风格）'},
      {term: 'assai',desc: '非常'},
      {term: 'con',desc: '带有'},
      {term: 'ma',desc: '但'},
      {term: 'ma non tanto',desc: '但不太'},
      {term: 'ma non troppo',desc: '但不过分'},
      {term: 'meno',desc: '较不'},
      {term: 'molto',desc: '甚'},
      {term: 'non',desc: '不'},
      {term: 'più',desc: '更'},
      {term: 'poco',desc: '稍微'},
      {term: 'poco a poco',desc: '逐渐'},
      {term: 'senza',desc: '无、不带有'},
      {term: 'simile',desc: '按照、同'},
      {term: 'subito',desc: '突然、快速'},
    ]
    return (
      <Table columns={columns} data={data} pagination={false}/>
    )
  }
  getBody() {
    return (
      <Typography style={{ textAlign: 'left', padding: '20px' }}>
        <Title heading={1}>音乐术语</Title>
        <Paragraph>
          在西方古典音乐的历史中，意大利一直是音乐艺术的中心，意大利语在18世纪前后也是欧洲的一种通用语言，特别是在音乐界，意大利的音乐家和作曲家可以到欧洲各地工作，他们使用意大利语作为他们之间的共同语言进行交流，所以音乐术语到今天一般都使用意大利语。
        </Paragraph>
        <Title heading={5}>1. 速度</Title>
        <Paragraph>
          谱上指示的每分钟拍数（BPM）仅是一般的指引。在现代乐中，节拍器标记指示的 BPM 拍数（例如 ♩= 120）可以作为速度标记的补充或替代。以下列表为速度标记：
        </Paragraph>
        {this.getTable1()}
        <Title heading={6}>速度的改变</Title>
        <Paragraph type='secondary'>
        下列为速度变化的术语和缩写。渐进式的变化术语可以用破折号来延伸，以表示变化的持续时间，例如 "rit.  _  _  _"。
        </Paragraph>
        {this.getTable2()}
        <Title heading={5}>2. 力度</Title>
        <Paragraph>
        下列为常见的力度记号；这些记号表示响度的相对变化，并不是指特定的音量级别。与其他意大利术语记号相反的是，力度记号标记通常会写在五线之下，或介于两个五线之间。
        </Paragraph>
        {this.getTable3()}
        <Title heading={6}>力度变化</Title>
        <Paragraph type='secondary' spacing='close'>
        下列为力度变化。渐强渐弱符号 (CrescendoDiminuendo) 用于表示几个小节的力度变化，而 cresc. 和 dim. 则用来表示较长乐句的力度变化。术语的指示则可以用破折号来延伸，以表示变化的持续时间。
        </Paragraph>
        {this.getTable4()}
        <Title heading={5}>3. 技巧</Title>
        <Paragraph>
        下列为常见的演奏技巧术语，这些术语指示演奏者使用特定的演奏技巧，以产生所需的声响。
        </Paragraph>
        {this.getTable5()}
        <Title heading={5}>4. 情绪</Title>
        <Paragraph>
        以下为常用的情绪术语。这些术语可帮助演奏者通过节奏、力度和演奏技巧来捕捉作品的情绪。
        </Paragraph>
        {this.getTable6()}
        <Title heading={5}>5. 反复记号</Title>
        <Paragraph>
        下列为反复记号。这些反复记号指示演奏者重复演奏作品的某些段落。
        </Paragraph>
        {this.getTable7()}
        <Title heading={5}>6. 一般术语</Title>
        <Paragraph>
        下列为一般术语，这些术语一般用来修饰其他术语 allegro molto（非常快）和 con amore（带有爱的）。
        </Paragraph>
        {this.getTable8()}
      </Typography>
    )
  }
  render() {
    return (
      <div>
        {this.getBody()}
      </div>
    );
  }
}

